import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,FormControl, Validators } from '@angular/forms';
import {Router, ActivatedRoute } from "@angular/router";
import { ApiService } from "../../services/api.service";
import { NgxSpinnerService } from "ngx-spinner";
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss']
})
export class ChangepasswordComponent implements OnInit {
  changePasswordForm:any;
  submitted = false; closeResult: any = '';suucessPassMsg:any='';
  password:string='';
  re_password:string='';errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  userId:any='';userLoginData:any=[];
  adminData: any;
  adminLogin: any;
  constructor(private auth:ApiService,
    private route: ActivatedRoute,
    private router: Router,private spinner: NgxSpinnerService,private formbuilder:FormBuilder,private modalService: NgbModal) {
    }
   
  ngOnInit(): void {
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.adminLogin = JSON.parse(localStorage.getItem('adminLoginPass') || '[]');
   // console.log(this.userLoginData);
    this.changePasswordForm = this.formbuilder.group({
      // Validators.pattern("/^(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,20}$/")
      user_id: [this.userLoginData.user_id ? this.userLoginData.user_id: this.adminData.user_id],
      old_password: ['',[Validators.required]],
      new_password: ['',[Validators.required,Validators.minLength(6),Validators.maxLength(10)]],
      email: [this.userLoginData.email ? this.userLoginData.email: this.adminLogin.email]  
    });
  }
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  get f() { return this.changePasswordForm.controls; }
  changePass(form:any){
    //this.token = this.route.snapshot.params.token;
    this.submitted = true;
    this.errorInfo.isError== false
     //stop here if form is invalid
     if (this.changePasswordForm.invalid) {
           return;
     }
     this.spinner.show();
   //console.log(this.changePasswordForm.value);return false;
     this.auth.changePassword(this.changePasswordForm.value).subscribe(
       data => {
          // console.log(data);
            if(data.status == 200){
              this.suucessPassMsg = 'Your password has been changed. Please login again';
              document.getElementById('successPass')?.click();
              this.router.navigateByUrl('/'); 
             this.router.navigate(['/']);
             this.spinner.hide();
             }else if(data.status == 400){
              this.spinner.hide();
              this.errorInfo.isError = true;
            this.errorInfo.errorMsg = data.message;
          }
       },
       error => {
        //alert(error);
      });  
 }
}
